import type { StateCreator } from 'zustand';
import { Screen } from '@/types';

import {
  RightPanelTab,
  type AppExperience,
  type NavigationSlice,
} from './types';

export type { NavigationSlice, AppExperience } from './types';
export { RightPanelTab } from './types';

export const navigationInitialState = {
  screen: Screen.Library,
  rightPanelTab: RightPanelTab.Presets,
  presetFeedEntrySlug: null as string | null,
  feedReturnSlug: null as string | null,
  isProfileOpen: false,
  isSettingsOpen: false,
  isCreditsOpen: false,
  isSearchOpen: false,
  profileTab: 0,
  hasSeenFeedScrollHint: false,
  appExperience: 'create' as AppExperience,
};

export const createNavigationSlice: StateCreator<
  NavigationSlice,
  [],
  [],
  NavigationSlice
> = (set, get) => ({
  ...navigationInitialState,

  setScreen: (screen) => {
    if (get().screen !== screen) {
      set({ screen });
    }
  },

  setRightPanelTab: (rightPanelTab) => set({ rightPanelTab }),

  setPresetFeedEntrySlug: (presetFeedEntrySlug) => set({ presetFeedEntrySlug }),

  setFeedReturnSlug: (feedReturnSlug) => set({ feedReturnSlug }),

  setIsProfileOpen: (isProfileOpen) => set({ isProfileOpen }),

  markFeedScrollHintSeen: () => set({ hasSeenFeedScrollHint: true }),
});
